import useHelpers from 'hooks/helpers';
import TeamListingCard from 'components/Tiles/TeamListingCard';

const TeamListingCards = ({ rendering, fields }): JSX.Element => {
  const { anchorId } = useHelpers(rendering);
  return (
    <section id={anchorId} data-e2e-component-uid={rendering.uid}>
      {fields.items.map((item, index) => (
        <div
          key={item.id}
          className={index % 2 == 0 ? 'background-white' : 'background-digital-light-grey'}
        >
          <TeamListingCard fields={item.fields} index={index} className="col-12" />
        </div>
      ))}
    </section>
  );
};

export default TeamListingCards;
